import { render, staticRenderFns } from "./BackdropName.vue?vue&type=template&id=357d614d&scoped=true&"
import script from "./BackdropName.vue?vue&type=script&lang=js&"
export * from "./BackdropName.vue?vue&type=script&lang=js&"
import style0 from "./BackdropName.vue?vue&type=style&index=0&id=357d614d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "357d614d",
  null
  
)

export default component.exports